import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import { APIURL, TZ } from "../../../Global";
import Pagination from "react-js-pagination";
import "../regdhospital.css"
import "../pagination.css";
import "../service.css"
import "../labsp.css"
import { useAlert } from 'react-alert';

function ApprovalHome() {
  const alert = useAlert()
  const { state } = useLocation()
  const [selected, setSelected] = useState(state && state.approve ? "approved" : "modern")
  const [searchTermMed, setSearchTermMed] = useState("");
  const [perPage,] = useState(10);
  const navigate = useNavigate();
  const { status } = useParams();
  const [medicine, setMedicine] = useState([])
  let lastScrollTop1 = 0;
  const [refresh, setRefresh] = useState(false)
  const [page1, setPage1] = useState(1)
  let lastScrollLeft1 = 0;
  let lastPageCalled1 = 1
  const [hasNext1, setHasNext1] = useState(false)
  const [progressId, setProgressId] = useState(null)
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const scrollContainer = document.getElementById('docScrollable');
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll1);

      return () => {
        scrollContainer.removeEventListener('scroll', handleScroll1);
      };
    }
  }, [page1, hasNext1]);
  const handleScroll1 = (event) => {
    const scrollContainer = event.target;
    const { scrollTop, scrollLeft, clientHeight, scrollHeight, clientWidth, scrollWidth } = scrollContainer;

    const isVerticalScroll = Math.abs(scrollTop - lastScrollTop1) > Math.abs(scrollLeft - lastScrollLeft1);
    lastScrollTop1 = scrollTop;
    lastScrollLeft1 = scrollLeft;

    const isBottom = scrollTop + clientHeight >= scrollHeight - 10;

    if (isBottom && hasNext1 && isVerticalScroll && (page1 !== lastPageCalled1)) {
      handleLoad(page1);
      lastPageCalled1 = page1;
    }
  };
  useEffect(() => {


    lastPageCalled1 = 1

    setPage1(1)
    setMedicine([])


    handleLoad(1);

  }, [refresh, selected, searchTermMed]);

  const handleLoad = async (currentPage) => {
    const tokenString = sessionStorage.getItem('usertoken');

    let str = tokenString.replace(/["]+/g, '')
    setIsLoading(true);
    axios.get(`${APIURL}/api/v1/staff/client-medicine-approval/?healthcare_type=${selected === "modern" ? "ModernMedicine" : "Unani"}&search=${searchTermMed.trim()}&per_page=10&page=${currentPage}`, {
      headers: {

        "Authorization": 'Token ' + str
      }
    })
      .then(res => {

        if (res.data.status === "success") {
          let Data = []
          Data = res.data.data

          setMedicine([...medicine, ...Data])

          setHasNext1(res.data.has_next)
          setPage1(res.data.page + 1)
        }


      })
      .catch(err => {

      }).finally(() => {
        setIsLoading(false);
      });


  }

  const handleUpdate = (med, status) => {
    document.getElementById("approve-btn").disabled = true;
    document.getElementById("reject-btn").disabled = true;
    setProgressId(med.id)
    const tokenString = sessionStorage.getItem("usertoken");
    let str = tokenString.replace(/["]+/g, "");
    const dataToUpdate = {
      cml_id: med.id,
      status: status
    }
    axios
      .put(`${APIURL}/api/v1/staff/client-medicine-approval/`, dataToUpdate, {
        headers: {
          Authorization: "Token " + str,
          "Content-Type": "application/json",
        },
      })

      .then((res) => {

        if (res.data.status === "success") {

          alert.success(res.data.message)
          setMedicine([])
          setRefresh(!refresh)
        } else {
          alert.error(res.data.message);
        }
      })
      .catch((err) => {
        alert.error("error in submission")
      }).finally(() => {
        setProgressId(null)
      })

  };


  return (

    <div className='row ' style={{ marginTop: "1%", width: "100%", minHeight: "71vh" }}>

      <div className="col-3">
        <h4 className="" style={{ color: "#55479F", paddingLeft: "2%" }}>CLINICS </h4>
        <div className="det-div " style={{ padding: "1%" }}>


          <button className={selected === "modern" ? "patientRecbutton1" : "patientRecbutton"}
            style={{ width: "100%", }}
            onClick={() => {
              setMedicine([]); setSelected("modern")
            }}
          >
            &nbsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48"><path fill="currentColor" fillRule="evenodd" d="M20 4a3 3 0 0 0-3 3h-3a3 3 0 0 0-3 3v28a3 3 0 0 0 3 3h12v-2H14a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1h3a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3h3a1 1 0 0 1 1 1v15h2V10a3 3 0 0 0-3-3h-3a3 3 0 0 0-3-3h-8Zm-1 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V7Zm4 12v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3Zm4 9a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6.789a7 7 0 0 1-3.117 5.824l-3.328 2.22a1 1 0 0 1-1.11 0l-3.328-2.22A7 7 0 0 1 27 34.79V28Zm2 1v5.789a5 5 0 0 0 2.227 4.16L34 40.8l2.773-1.85A5 5 0 0 0 39 34.79V29H29Zm4.707 7.707l4-4l-1.414-1.414L33 34.586l-1.293-1.293l-1.414 1.414l2 2a1 1 0 0 0 1.414 0Z" clipRule="evenodd" /></svg>
            &nbsp;
            Modern Medicine{" "}

          </button>
          <button className={selected === "unani" ? "patientRecbutton1" : "patientRecbutton"}
            style={{ width: "100%" }}
            onClick={() => {
              setMedicine([]); setSelected("unani")
            }}
          >
            &nbsp;
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 9a2 2 0 1 0 0 4a2 2 0 0 0 0-4Zm-4 8.5a3 3 0 0 1 3-3h2a3 3 0 0 1 3 3a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Z" /><path fill="currentColor" fillRule="evenodd" d="M7 2.25A2.75 2.75 0 0 0 4.25 5v14A2.75 2.75 0 0 0 7 21.75h10A2.75 2.75 0 0 0 19.75 19V8.198a1.75 1.75 0 0 0-.328-1.02L16.408 2.98a1.75 1.75 0 0 0-1.421-.73H7ZM5.75 5c0-.69.56-1.25 1.25-1.25h7.25v4.397c0 .414.336.75.75.75h3.25V19c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25V5Z" clipRule="evenodd" /></svg>
            &nbsp;
            Unani{" "}

          </button>


        </div>
      </div>



      <div className="col-9" style={{ minHeight: "71vh" }}>

        <div className="search-div row" style={{ margin: "auto" }}>
          <div className="col-11" >

            <input

              type="text"
              className="search-clinics"
              placeholder="Search medicine"
              value={searchTermMed}
              onChange={(e) => { setMedicine([]); setSearchTermMed(e.target.value) }}
            // style={{ paddingLeft: "10px", width: "100%",borderRadius:"5px 0px 0px 5px",border:"1px solid " }}
            />


          </div>

        </div>

        <div className="">

          <div style={{ marginBottom: "2%" }} className="row" >
            {isLoading && medicine.length === 0 ? (
              <div style={{ textAlign: "center", padding: "10%", width: "100%" }}>
                <h4>Loading Medicines...</h4>
              </div>
            ) :
              medicine.length > 0 ?


                <div className="" style={{}}>
                  <h6 className="row"><span className="col-3" ></span>
                    <div className="col-7"></div>
                    <div className="col-2">

                      {/* <button onClick={() => {  setInvoiceShow(true)  }
                         } style={{ backgroundColor:"rgb(85, 71, 159)" }} className="clinic_button">
                          Generate invoice
                         </button> */}

                    </div>

                  </h6>
                  <div id="docScrollable" style={{ overflowY: "auto", overflowX: "hidden", maxHeight: "380px", paddingRight: "2%", paddingLeft: "2%", marginBottom: "2%" }}>
                    <div className="row " style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", textAlign: "left", padding: "1%", borderRadius: "5px 5px 0px 0px" }}>
                      {/* <div  className="col-1">ID</div> */}
                      <div className="col-3"><b >Medicine</b></div>
                      <div className="col-3"><b >Clinic</b></div>
                      <div className="col-2"><b >Created by</b></div>

                      {/* <div className="col-2"><b >Strength </b></div> */}
                      <div className="col-2"><b >Requested </b></div>


                      <div className="col-2"></div>

                    </div>

                    {medicine && medicine.map((item) => {
                      return (<div className="row " style={{ textAlign: "left", borderLeft: "0.4px solid gray", borderBottom: "0.4px solid gray", borderRight: "0.4px solid gray", fontSize: "13px", }}>

                        <div style={{ padding: "1%", textTransform: "capitalize", color: "blue", cursor: "pointer" }} className="col-3"><spsn style={{}}>{item.id}</spsn>{" "}{item.med_name}</div>
                        <div style={{ padding: "1%", overflow: "clip" }} className="col-3"> {item.hospital_name}</div>
                        <div style={{
                          padding: "1%",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis"
                        }} className="col-2">{item.created_by_name}</div>
                        {/* <div style={{  padding: "1%"}}className="col-2" > {item.strength}{item.strength_unit}</div> */}
                        <div style={{ padding: "1%" }} className="col-2"> {item.created_at && new Date(item.created_at).toLocaleDateString()}</div>
                        <div style={{ padding: "1%" }} className="col-2">
                          <button id="approve-btn" onClick={() => { handleUpdate(item, "approved") }} disabled={progressId !== null}
                            style={{ backgroundColor: "green", width: "46%" }} className="clinic_button">{progressId === item.id ? "..." : "Approve"}</button>
                          &nbsp;&nbsp;
                          <button id="reject-btn" onClick={() => { handleUpdate(item, "rejected") }} disabled={progressId !== null}
                            style={{ backgroundColor: "red", width: "46%" }} className="clinic_button">{progressId === item.id ? "..." : "Reject"}</button>
                        </div>

                      </div>
                      )
                    })}

                  </div>

                </div>

                :
                <div
                  style={{
                    color: "red",
                    fontSize: "25px",
                    height: "200px",
                    padding: "10%",
                  }}
                >
                  <h4>No Medicines!!</h4>
                </div>
            }
          </div>
        </div>
      </div>

    </div>
  )
}

export default ApprovalHome
